import { useState, useMemo } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { jsx as _jsx } from "react/jsx-runtime";
function IntegrationsFilter({
  appIntegrations,
  onChange,
  trackInteraction,
  value
}) {
  const [searchTracked, setSearchTracked] = useState(false);
  const options = useMemo(() => appIntegrations.map(text => ({
    text,
    value: text
  })), [appIntegrations]);
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('appMarketplace.storefront.filters.integrations.titleText'),
    multi: true,
    name: "integrations",
    onChange: onChange,
    onSearchBlur: () => setSearchTracked(false),
    onSearchChange: event => {
      const search = event.target.value;
      if (searchTracked || !search.trim()) return;
      trackInteraction('search app integrations');
      setSearchTracked(true);
    },
    options: options,
    scrollable: true,
    searchable: true,
    searchPlaceholder: unescapedText('appMarketplace.storefront.filters.integrations.searchInputPlaceholder'),
    value: value,
    virtualized: true
  });
}
export default IntegrationsFilter;